import * as AccessConfigurer from "./AccessConfigurer"

export const accessConfigurerRenderer = AccessConfigurer.renderer


// WEBPACK FOOTER //
// ./src/community2/community2.ts